import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { CommunicationService } from '../../shared/communication.service';
import { AnalyticsSearchDto } from '../../shared/analytics-search.dto';
import { AnalyticsSearchResultDto } from '../../shared/analytics-search-result.dto';
import { MemberEmailEngagementSearchDto } from '../../shared/member-email-engagement-search.dto';
import { MemberEmailEngagementGridComponent } from './member-email-engagement-grid/member-email-engagement-grid.component';
import { timeoutWrapper } from 'src/app/shared/decorator/timeout-wrapper';
import { MassCommUndeliverableEmailGridComponent } from './mass-comm-undeliverable-email-grid/mass-comm-undeliverable-email-grid.component';

import { ClickedEmailLinkSearchDto } from '../../shared/clicked-email-link-search.dto';
import { MassCommClickedEmailLinksGridComponent } from './mass-comm-clicked-email-links-grid/mass-comm-clicked-email-links-grid.component';

@Component({
  selector: 'wl-mass-comm-message-admin-analytics',
  templateUrl: './mass-comm-message-admin-analytics.component.html',
  styleUrl: './mass-comm-message-admin-analytics.component.less',
    standalone: false
})
export class MassCommMessageAdminAnalyticsComponent implements OnChanges {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @ViewChild(MemberEmailEngagementGridComponent) private _memberEmailEngagementGrid: MemberEmailEngagementGridComponent;
  @ViewChild(MassCommUndeliverableEmailGridComponent) private _undeliverableEmailGrid: MassCommUndeliverableEmailGridComponent;
  @ViewChild(MassCommClickedEmailLinksGridComponent) private _clickedEmailLinkGrid: MassCommClickedEmailLinksGridComponent;

  analyticsSearchResult = {} as AnalyticsSearchResultDto;

  public constructor(private _communicationService: CommunicationService) {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes.startDate || changes.endDate) {
      this.getDashboardAnalytics();
      this.memberEngagementSearch();
      this.unDeliverableEmailSearch();
      this.clickedEmailLinkSearch();
    }
  }

  public getDashboardAnalytics() {
    let searchDto = { StartDate: this.startDate, EndDate: this.endDate } as AnalyticsSearchDto;
    this._communicationService.getDashBoardAnalytics(searchDto).then((result: AnalyticsSearchResultDto) => {
      this.analyticsSearchResult = result;
    });
  }

  @timeoutWrapper()
  public memberEngagementSearch() {
    this._memberEmailEngagementGrid.searchParams.StartDate = this.startDate;
    this._memberEmailEngagementGrid.searchParams.EndDate = this.endDate;
    this._memberEmailEngagementGrid.search();
  }

  @timeoutWrapper()
  public clickedEmailLinkSearch() {
    this._clickedEmailLinkGrid.searchParams.StartDate = this.startDate;
    this._clickedEmailLinkGrid.searchParams.EndDate = this.endDate;
    this._clickedEmailLinkGrid.search();
  }

  @timeoutWrapper()
  public unDeliverableEmailSearch() {
    this._undeliverableEmailGrid.searchParams.StartDate = this.startDate;
    this._undeliverableEmailGrid.searchParams.EndDate = this.endDate;
    this._undeliverableEmailGrid.search();
  }
}
